import { createAction } from '@reduxjs/toolkit';
import { StoreErrorPayload } from 'types/StoreErrorPayload';
import { ErrorActionTypes } from './error.actions.types';

export const storeError = createAction<StoreErrorPayload>(ErrorActionTypes.StoreError);

export const clearStoreError = createAction<string>(ErrorActionTypes.ClearStoreError);
